import React, { useContext } from "react";

import { Context } from "../../utils/context";
import "./table.css";
import { NavLink } from "react-router-dom";

const ListItem = ({ item, headItemsQuantity }) => {
  const length = headItemsQuantity;
  const { setAction } = useContext(Context);

  return (
    <>
      <div className="listItem">
        <p>{item.Agent_Name}</p>
        <ul>
          <li>{item.Total_Calls}</li>
          <li>{item.Agent_Confidence}</li>
          <li>{item.Agent_Professionalism}</li>
          <li>{item["Customer_Understanding/Anticipation"]}</li>
          <li>
            {length === 5 && (
              <NavLink
                to={`/customer/${item.Agent_id}`}
                onClick={() => setAction("singleCustomer")}
              >
                <button>View</button>
              </NavLink>
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export default ListItem;
